var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"row p-5 bg-white"},[_c('NoRecords',{attrs:{"main_icon":"fa fa-screwdriver-wrench","value":"false","title":"This page is under construction","subtitle":"Please return later"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"page-header"},[_c('i',{staticClass:"fa fa-screwdriver-wrench"}),_vm._v(" Under construction"),_c('small')])
}]

export { render, staticRenderFns }